import React from 'react';
import PropTypes from 'prop-types';

const LinkButton = (props) => {
  const { className, buttonType, children, onClick, disabled } = props;

  return (
    <button className={`button ${buttonType} ${className} ${disabled ? 'disabled' : ''}`} onClick={onClick}>
      {children}
    </button>
  );

};

LinkButton.defaultProps = {
  buttonType: 'primary', //cta, ctaMin, navigate, navigateMin
  onClick: () => {},
  className: '',
};

LinkButton.propTypes = {
  buttonType: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default LinkButton;
